import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { InboxAIService } from '@app/shared/services/ai/InboxAI.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';
import { LoadingState } from '@ui';

// Define an AIMode enum in this component since we removed the one from AI.models
export enum AIMode {
  SUGGEST = 'suggest',
  IMPROVE = 'improve',
}

@Component({
  standalone: false,
  selector: 'sbnb-chatgpt-generate-button',
  templateUrl: './chatgpt-generate-button.component.html',
  styleUrls: ['./chatgpt-generate-button.component.scss'],
})
export class ChatgptGenerateButtonComponent implements OnInit, OnChanges {
  @Input() isDisabled: string | boolean;
  @Input() loadingState: boolean;
  @Input() mode: AIMode = AIMode.SUGGEST;
  @Output() buttonClicked: EventEmitter<AIMode> = new EventEmitter();
  @Output() disabledButtonClicked: EventEmitter<boolean> = new EventEmitter();

  LoadingState = LoadingState;
  AIMode = AIMode;
  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    private deviceDetectionService: DeviceDetectionService,
    private optimizely: OptimizelyService,
    protected aiService: InboxAIService
  ) {}

  // Add getters for the updated InboxAIService
  get isAiWorking(): boolean {
    return this.aiService.isWorking();
  }

  get progressMessage(): string | null {
    return this.aiService.$progressMessageSignal();
  }

  // Add a getter to convert isDisabled to boolean
  get isDisabledAsBool(): boolean {
    return this.isDisabled === true || this.isDisabled === 'true';
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  onButtonClick(isDisabled) {
    if (isDisabled) {
      this.disabledButtonClicked.emit(true);
    } else {
      this.buttonClicked.emit(this.mode);
    }
  }
}
